import type { IconData } from '../../types';

export const data: IconData = {
  o: '<circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/>',
  f: '<circle cx="5" cy="12" r="2"/><circle cx="12" cy="12" r="2"/><circle cx="19" cy="12" r="2"/>',
  vb: '0 0 24 24',
  rao: { fill: 'currentColor' },
  raf: { fill: 'currentColor' },
};

export default data;
